import Badge from "./badge";
var variants = Badge.variants,
  defaultProps = Badge.defaultProps;
var baseStyle = {
  fontFamily: "mono",
  fontSize: "sm",
  px: "0.2em",
  borderRadius: "sm"
};
export default {
  baseStyle: baseStyle,
  variants: variants,
  defaultProps: defaultProps
};